"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var emailValidator = require("email-validator");
var isUrl = require("is-url");
var DEFAULT_MESSAGE = 'This field is invalid';
var PatternMessages = {
    email: 'This is not a valid email',
    url: 'This is not a valid url'
};
/**
 * The validator function.
 */
exports.pattern = function (rule, msg) {
    var validator = function (opts) {
        var valid = false;
        var pattern = typeof rule === 'string' || rule instanceof RegExp ? rule : rule.pattern;
        var message = typeof rule === 'string' || rule instanceof RegExp ? msg : rule.msg;
        if (pattern === 'email') {
            valid = emailValidator.validate(opts.value);
        }
        else if (pattern === 'url') {
            valid = isUrl(opts.value);
        }
        else {
            valid = pattern.test(opts.value);
        }
        return (valid ||
            message ||
            (typeof pattern === 'string' && PatternMessages[pattern]) ||
            DEFAULT_MESSAGE);
    };
    return validator;
};
//# sourceMappingURL=patternValidator.js.map